import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { api, fmtQty, fmtDT } from "@/lib/api";
import { PageHeader, Empty, tableWrap, th, td, num } from "@/components/common";
import { qtyByUnit } from "@/pages/DispatchList";

export default function Outward() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  useEffect(() => { api.get("/outward", { params: { q, date_from: from, date_to: to } }).then((r) => setRows(r.data)); }, [q, from, to]);
  return (
    <div>
      <PageHeader title="Stock Outward" subtitle="Every item that left the warehouse, line by line. Outward entries are created through Dispatch." />
      <div className="flex flex-col sm:flex-row gap-2 mb-4">
        <Input placeholder="Search bill, party, vehicle, drum…" value={q} onChange={(e) => setQ(e.target.value)} className="sm:max-w-sm" data-testid="outward-search-input" />
        <Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="sm:w-40" data-testid="outward-from-input" />
        <Input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="sm:w-40" data-testid="outward-to-input" />
        <div className="text-sm font-mono self-center" data-testid="outward-total">Total {qtyByUnit(rows) || "0 m"}</div>
      </div>
      <div className={tableWrap}>
        <table className="w-full" data-testid="outward-table">
          <thead><tr>{["Date", "Time", "Dispatch", "Party", "Bill", "Brand", "Cable Size", "Item", "Qty", "Vehicle", "Handled By"].map((h) => <th key={h} className={th}>{h}</th>)}</tr></thead>
          <tbody>{rows.map((r) => (
            <tr key={`${r.dispatch_id}-${r.unit_id}`} className="hover:bg-muted/40">
              <td className={td}>{r.date}</td><td className={td}>{fmtDT(r.at).split(", ").pop()}</td>
              <td className={`${td} font-mono`}><Link to={`/dispatch/${r.dispatch_id}`} className="hover:underline">{r.dispatch_no}</Link></td>
              <td className={td}>{r.party_name}</td><td className={`${td} font-mono`}>{r.bill_no}</td><td className={td}>{r.brand}</td><td className={td}>{r.cable_size}</td>
              <td className={`${td} font-mono`}>{r.unit_code}</td><td className={`${td} ${num}`}>{fmtQty(r.qty, r.uom)}</td><td className={`${td} font-mono`}>{r.vehicle_no}</td><td className={td}>{r.taken_by || r.issued_by}</td>
            </tr>
          ))}</tbody>
        </table>
        {!rows.length && <Empty text="No outward movements" />}
      </div>
    </div>
  );
}
